import { ProductoPlanCargoService } from './../../_services/producto-plan-cargo.service';
import { ProductoPlanCargo } from './../../_models/producto-plan-cargo';
import { Component, OnInit } from '@angular/core';
import { Producto } from '../../_models/producto';
import { ProductoService } from '../../_services/producto.service';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { NavService } from '../../_services/_nav.service';
import { ProductoDestino } from '../../_models/producto-destino';
import { ProductoDestinoService } from '../../_services/producto-destino.service';
import { ProductoMonto } from '../../_models/producto-monto';
import { ProductoMontoService } from '../../_services/producto-monto.service';
import { ProductoDestinoMonto } from '../../_models/producto-destino-monto';
import { ProductoDestinoMontoService } from '../../_services/producto-destino-monto.service';
import { ProductoMontoAliado } from '../../_models/producto-monto-aliado';
import { ProductoMontoAliadoService } from '../../_services/producto-monto-aliado.service';
import { ProductoFrecuencia } from '../../_models/producto-frecuencia';
import { ProductoFrecuenciaService } from '../../_services/producto-frecuencia.service';
import { ProductoGarantia } from '../../_models/producto-garantia';
import { ProductoGarantiaService } from '../../_services/producto-garantia.service';
import { ProductoRenovacion } from '../../_models/producto-renovacion';
import { ProductoRenovacionService } from '../../_services/producto-renovacion.service';
import { ProductoEstado } from '../../_models/producto-estado';
import { ProductoEstadoService } from '../../_services/producto-estado.service';
import { ProductoEstadoRelacion } from '../../_models/producto-estado-relacion';
import { ProductoEstadoRelacionService } from '../../_services/producto-estado-relacion.service';
import { ProductosEstadosRelacionesTiposPreaprobados } from '../../_models/productos-estados-relaciones-tipos-preaprobados';
import { ProductosEstadosRelacionesTiposPreaprobadosService } from '../../_services/productos-estados-relaciones-tipos-preaprobados.service';
import { ProductoReferencia } from '../../_models/producto-referencia';
import { ProductoReferenciaService } from '../../_services/producto-referencia.service';
import { ProductoActividad } from '../../_models/producto-actividad';
import { ProductoActividadService } from '../../_services/producto-actividad.service';
import { ListaService } from '../../_services/lista.service';
import { ListaItem } from '../../_models/lista-item';
import { ProductoControl } from '../../_models/producto-control';
import { ProductoCuestionario } from '../../_models/producto-cuestionario';
import { ProductoCuestionarioService } from '../../_services/producto-cuestionario.service';
import { ProductoControlService } from '../../_services/producto-control.service';
import { ProductoConfirmacionVinculacionService } from '../../_services/producto-confirmacion-vinculacion.service';
import { ProductoConfirmacionVinculacion } from '../../_models/producto-confirmacion-vinculacion';
import { ProductoAutorizacionService } from '../../_services/producto-autorizacion.service';
import { ProductoAutorizacion } from '../../_models/producto-autorizacion';
import { ProductoCuestionarioVoluntadPago } from '../../_models/producto-cuestionario-voluntad-pago';
import { ProductoCuestionarioVoluntadPagoService } from '../../_services/producto-cuestionario-voluntad-pago.service';
import { ProductoSeguroAnalizamosService } from '../../_services/producto-seguro-analizamos.service';
import { ProductoSeguroAnalizamos } from '../../_models/producto-seguro-analizamos';
import { ProductoDesembolsoService } from '../../_services/producto-desembolso.service';
import { ProductoDesembolso } from '../../_models/producto-desembolso';
import { ProductoFormaDesembolso } from '../../_models/producto-forma-desembolso';
import { ProductoFormaDesembolsoService } from '../../_services/producto-forma-desembolso.service';
import { ProductoRestriccionOficinaService } from '../../_services/producto-restriccion-oficina.service';
import { ProductoRestriccionOficina } from '../../_models/producto-restriccion-oficina';
import { ProductoRestriccionBarrioService } from '../../_services/producto-restriccion-barrio.service';
import { ProductoRestriccionBarrio } from '../../_models/producto-restriccion-barrio';
import { ProductoReglaNegocio } from '../../_models/producto-regla-negocio';
import { ProductoReglaNegocioService } from '../../_services/producto-regla-negocio.service';
import {ProductosRespaldos} from '../../_models/productos-respaldos';
import {ProductosRespaldosService} from '../../_services/productos-respaldos.service';
import { ProductoSeguroTipoConstruccionService } from '../../_services/producto-seguro-tipo-construccion.service';
import { ProductoSeguroTipoDireccionService } from '../../_services/producto-seguro-tipo-direccion.service';
import { ProductoSeguroClaseViviendaService } from '../../_services/producto-seguro-clase-vivienda.service';
import {firstValueFrom, forkJoin} from 'rxjs';
import {CreditosDigital, TiposCuentaAhorro, TiposProductosBancarios} from '../../_enums/enum';
import { SafeResourceUrl } from '@angular/platform-browser';
import { AdjuntoService } from '../../_services/adjunto.service';
import {ProductosMediosAsociados} from '../../_models/productos-medios-asociados';
import {ProductosSolicitudesLlaves} from '../../_models/productos-solicitudes-llaves';
import {ProductosMediosAsociadosService} from '../../_services/productos-medios-asociados.service';
import {ProductosSolicitudesLlavesService} from '../../_services/productos-solicitudes-llaves.service';
import {SelectItem} from 'primeng/api';
import {ProductoTipoInteres} from '../../_models/producto-tipo-interes';
import {ProductoTipoInteresService} from '../../_services/producto-tipo-interes.service';

@Component( {
  selector: 'app-producto-detalle',
  templateUrl: 'producto-detalle.component.html',
  styleUrls: ['producto-detalle.component.scss']
} )

export class ProductoDetalleComponent implements OnInit {
  producto: Producto;
  carInformacionInicial = true;
  colPlanCargo: any[];
  lisProductoPlanCargo: ProductoPlanCargo[] = [];
  carTablaPlanCargo = true;
  colDestinos: any[];
  lisProductoDestinos: ProductoDestino[] = [];
  carTablaDestinos = true;
  colMontos: any[];
  lisProductoMontos: ProductoMonto[] = [];
  carTablaMontos = true;
  colMontosDestinos: any[];
  lisProductoMontoDestinos: ProductoDestinoMonto[] = [];
  carTablaMontosDestinos = true;
  colMontosAliados: any[];
  lisProductoMontoAliados: ProductoMontoAliado[] = [];
  carTablaMontosAliado = true;
  desAliado: ProductoDestino;
  colFrecuencias: any[];
  lisProductoFrecuencias: ProductoFrecuencia[] = [];
  carTablaFrecuencias = true;
  colGarantias: any[];
  lisProductoGarantias: ProductoGarantia[] = [];
  carTablaGarantias = true;
  colRenovacion: any[];
  lisProductoRenovacion: ProductoRenovacion[] = [];
  carTablaRenovacion = true;
  colEstados: any[];
  lisProductoEstados: ProductoEstado[] = [];
  lisProductoEstados2: ProductoEstado[] = [];
  carTablaEstado = true;
  colEstadoRelaciones: any[];
  lisEstadoRelaciones: ProductoEstadoRelacion[] = [];
  lisEstadoRelacionesTiposPreaprobados: ProductosEstadosRelacionesTiposPreaprobados[] = [];
  proEstadoSeleccionado: ProductoEstado;
  carTablaEstadoRelaciones = false;
  mosEstadoRelaciones = false;
  colReferencias: any[];
  lisProductoReferencias: ProductoReferencia[] = [];
  carTablaReferencia = true;
  colActividades: any[];
  lisProductoActividad: ProductoActividad[] = [];
  carTablaActividades = true;
  lisTipoDatoTodos: ListaItem[] = [];
  colFrecuenciaAliados: any[];
  lisProductoFrecuenciaAliado: ProductoFrecuencia[] = [];
  colControles: any[];
  lisProductoControles: ProductoControl[] = [];
  lisProductoControles2: ProductoControl[] = [];
  carTablaControles = true;
  colCuestionarios: any[];
  carTablaCuestionarios = true;
  lisProductoCuestionarios: ProductoCuestionario[] = [];
  carTablaConfirmacionVinculacion = true;
  colConfirmacionVinculacion: any[];
  lisProductoConfirmacionVinculacion: ProductoConfirmacionVinculacion[] = [];
  carTablaAutorizacion = true;
  colAutorizacion: any[];
  lisProductoAutorizacion: ProductoAutorizacion[] = [];
  lisProductoAutorizacionContrato: ProductoAutorizacion[] = [];
  carTablaVoluntadPago = true;
  colVoluntadPago: any[];
  lisProductoVoluntadPago: ProductoCuestionarioVoluntadPago[] = [];
  carTablaSeguroAnalizamos = true;
  colSeguroAnalizamos: any[];
  lisProductoSeguroAnalizamos: ProductoSeguroAnalizamos[] = [];
  carTablaDesembolso = true;
  colDesembolso: any[];
  colDesembolso2: any[];
  lisProductoDesembolso: ProductoDesembolso[] = [];
  carTablaFormaDesembolso = true;
  colFormaDesembolso: any[];
  lisProductoFormaDesembolso: ProductoFormaDesembolso[] = [];
  carTablaRestriccionOficina = true;
  colRestriccionOficina: any[];
  lisProductoRestriccionOficina: ProductoRestriccionOficina[] = [];
  carTablaRestriccionBarrio = true;
  colRestriccionBarrio: any[];
  lisProductoRestriccionBarrio: ProductoRestriccionBarrio[] = [];
  carTablaReglasNegocios = true;
  colReglasNegocio: any[] = [];
  lisReglasNegocios: ProductoReglaNegocio[] = [];
  carTablaProductosRespaldos = true;
  colProductosRespaldos: any[];
  lisProductoRespaldos: ProductosRespaldos[] = [];
  proFrecuencia: ProductoFrecuencia;
  showModalFrecuenciasCuotas = false;
  tabSeleccionado = 'PRODUCTO';
  canales  = CreditosDigital;
  imagen: SafeResourceUrl;

  codeTipoProductoBancario: string;
  codeTipoCuentaAhorro: string;
  productosMediosAsociados: ProductosMediosAsociados[] = [];
  productosSolicitudesLlaves: ProductosSolicitudesLlaves[] = [];

  mediosAsociados: string;
  solicitudesLlaves: string;
  productoTiposIntereses: string;

  constructor( private proServicio: ProductoService,
               private navServicio: NavService,
               private proPlanCargoServicio: ProductoPlanCargoService,
               private proDestinosServicio: ProductoDestinoService,
               private proMontoServicio: ProductoMontoService,
               private proMontoDestinoServicio: ProductoDestinoMontoService,
               private proMontosAliadosServicio: ProductoMontoAliadoService,
               private proFrecuenciasServicio: ProductoFrecuenciaService,
               private proGarantiaServicio: ProductoGarantiaService,
               private proRenovacionservicio: ProductoRenovacionService,
               private proEstadoServicio: ProductoEstadoService,
               private proEstadoRelacionServicio: ProductoEstadoRelacionService,
               private proEstadoRelacionTipoPreAprobadoServicio: ProductosEstadosRelacionesTiposPreaprobadosService,
               private proReferenciaServicio: ProductoReferenciaService,
               private proActividadServicio: ProductoActividadService,
               private proCuestionarioServicio: ProductoCuestionarioService,
               private proControlServicio: ProductoControlService,
               private proConfVincServicio: ProductoConfirmacionVinculacionService,
               private proAutorizacionServicio: ProductoAutorizacionService,
               private proVoluntadPagoServicio: ProductoCuestionarioVoluntadPagoService,
               private proSeguroAnalizamosServicio: ProductoSeguroAnalizamosService,
               private proDesembolsoServicio: ProductoDesembolsoService,
               private proFormaDesembolsoServicio: ProductoFormaDesembolsoService,
               private proRestriccionOficinaServicio: ProductoRestriccionOficinaService,
               private proRestriccionBarrioServicio: ProductoRestriccionBarrioService,
               private lisServicio: ListaService,
               private proReglaNegocioServicio: ProductoReglaNegocioService,
               private proRespaldoServicio: ProductosRespaldosService,
               private proSeguroTipoConstruccionService: ProductoSeguroTipoConstruccionService,
               private proSeguroTipoDireccionService: ProductoSeguroTipoDireccionService,
               private proSeguroClaseViviendaService: ProductoSeguroClaseViviendaService,
               private route: ActivatedRoute, private location: Location,
               private adjuntosService: AdjuntoService,
               private productosMediosAsociadosService: ProductosMediosAsociadosService,
               private productosSolicitudesService: ProductosSolicitudesLlavesService,
               private productoTipoInteresService: ProductoTipoInteresService,
               ) {
  }

  async ngOnInit():  Promise<void> {
    this.cargarColumnas();
     const [listaTiposDatos] = await forkJoin(this.lisServicio.getMasterDetails( 'ListasTiposDatosConceptos' )
       ).toPromise();

    this.lisTipoDatoTodos = listaTiposDatos;


    this.route.params.subscribe( ( params: Params ) => {
      const idProducto = params[ 'id' ];
      this.proServicio.obtenerPorId( idProducto ).subscribe( async producto => {
        this.producto = producto;
        this.codeTipoProductoBancario = producto.codigoTipoProductoBancario != null ? producto.codigoTipoProductoBancario : 'CREDIT';
        this.codeTipoCuentaAhorro = producto.codigoTipoCuentaAhorro ?? null;
        if ( this.producto.idAdjuntoIcono ) {
          this.cargarlogoInicial(this.producto.idAdjuntoIcono);
        }

        if(this.codeTipoProductoBancario == this.codigosProducto.INVERSION) {
          const productoTiposIntereses: ProductoTipoInteres[] = await firstValueFrom(this.productoTipoInteresService.getByIdProducto(params['id']));
          this.productoTiposIntereses = productoTiposIntereses.map(e => e.tipoInteres).filter(Boolean).join(', ');
        }
        this.carInformacionInicial = false;
      } );

      this.proPlanCargoServicio.listadoPorProducto( idProducto ).subscribe( rta => {
        this.lisProductoPlanCargo = rta.filter( x => x.indicadorHabilitado );
        this.carTablaPlanCargo = false;
      } );

      /*this.proDestinosServicio.listadoPorProducto( idProducto ).subscribe( rta => {
        this.lisProductoDestinos = rta.filter( x => !x.indicadorAliado );
        const a = this.lisProductoDestinos.find( x => x.indicadorAliado );
        if ( a ) {
          this.desAliado = a;
        }
        this.carTablaDestinos = false;
      } );*/

      this.proMontoServicio.listadoPorProducto( idProducto ).subscribe( rta => {
        rta.sort( function( a, b ) {
          if ( Number(a.montoMaximo) < Number(b.montoMaximo) ) {
            return -1;
          } else {
            return 1;
          }
        } );
        this.lisProductoMontos = rta;
        this.carTablaMontos = false;
      } );

      /*this.proMontoDestinoServicio.listadoPorProducto( idProducto ).subscribe( rta => {
        this.lisProductoMontoDestinos = rta;
        this.carTablaMontosDestinos = false;
      } );*/

      /*this.proMontosAliadosServicio.listadoPorProductoHabilitado( idProducto ).subscribe( rta => {
        this.lisProductoMontoAliados = rta;
        this.carTablaMontosAliado = false;
      } );*/

      this.proFrecuenciasServicio.listadoPorProducto( idProducto ).subscribe( rta => {
        rta.map( ( s: ProductoFrecuencia ) => {
          if ( s.indicadorAliado ) {
            this.lisProductoFrecuenciaAliado.push( s );
          } else {
            this.lisProductoFrecuencias.push( s );
          }
        } );
        this.carTablaFrecuencias = false;
      } );

      this.proGarantiaServicio.listadoPorProducto( idProducto ).subscribe( rta => {
        rta.map( ( s: ProductoGarantia ) => {
          s.rangoMonto = s.montoMinimo + ' - ' + s.montoMaximo;
          this.lisProductoGarantias.push( s );
        } );
        this.carTablaGarantias = false;
      } );

      this.proRenovacionservicio.listadoPorProducto( idProducto ).subscribe( rta => {
        rta.map( ( s: ProductoRenovacion ) => {
          if ( !s.idPerfilRiesgo ) {
            s.perfilRiesgo = this.navServicio.buscarMensaje( 'LBL_TODOS' );
          }
          s.rangoPlazo = s.plazoMinimo + ' - ' + s.plazoMaximo;
          this.lisProductoRenovacion.push( s );
        } );
        this.carTablaRenovacion = false;
      } );

      this.proEstadoServicio.listadoPorProducto( idProducto ).subscribe( rta => {
        this.lisProductoEstados = rta;
        /* this.lisProductoEstados2 = rta.filter( h => h.indicadorAliado ); */
        this.carTablaEstado = false;
      } );

      this.proReferenciaServicio.listadoPorProductoTipoPersona( idProducto ).subscribe( rta => {
        this.lisProductoReferencias = rta;
        this.lisProductoReferencias.forEach(x => {
          if (Array.isArray(x.naturaleza) && x.naturaleza.length > 0) {
            const lista = x.naturaleza.filter(l =>l.indicadorHabilitado ).map(l => l.tipoPersona);
            x.tipoPersona = lista.join(',');

          }
        });

        this.carTablaReferencia = false;
      } );

      this.proActividadServicio.listadoPorProducto( idProducto ).subscribe( rta => {
        this.lisProductoActividad = rta;
        this.carTablaActividades = false;
      } );

      this.proControlServicio.listadoPorProducto( idProducto ).subscribe( rta => {
        this.lisProductoControles = rta.filter( x => x.indicadorHabilitado );
        /* this.lisProductoControles2 = rta.filter( x => x.indicadorHabilitado && x.indicadorAliado ); */
        this.carTablaControles = false;
      } );

      this.proCuestionarioServicio.listadoPorProducto( idProducto ).subscribe( rta => {
        this.lisProductoCuestionarios = rta;
        this.carTablaCuestionarios = false;
      } );

      this.proConfVincServicio.listadoPorProducto( idProducto ).subscribe( confirmacionVinculacion => {
        this.lisProductoConfirmacionVinculacion = confirmacionVinculacion.filter( t => t.indicadorHabilitado );
        this.carTablaConfirmacionVinculacion = false;
      } );

      this.proAutorizacionServicio.listadoPorProducto( idProducto ).subscribe( proAutorizacion => {
        this.lisProductoAutorizacion = proAutorizacion.filter( t => t.indicadorHabilitado && !t.indicadorAplicaContrato );
        this.lisProductoAutorizacionContrato = proAutorizacion.filter( t => t.indicadorHabilitado && t.indicadorAplicaContrato );
        this.carTablaAutorizacion = false;
      } );

      this.proVoluntadPagoServicio.listadoPorProducto( idProducto ).subscribe( voluntadPago => {
        this.lisProductoVoluntadPago = voluntadPago;
        this.carTablaVoluntadPago = false;
      } );

      forkJoin(this.proSeguroAnalizamosServicio.listadoPorProducto( idProducto ),
      this.proSeguroClaseViviendaService.listadoPorProductoHabilitado( idProducto ),
        this.proSeguroTipoConstruccionService.listadoPorProductoHabilitado( idProducto ),
        this.proSeguroTipoDireccionService.listadoPorProductoHabilitado( idProducto ),
      ).subscribe(([seguroAnalizamos, lisProductoClaseVivienda, lisProductoTipoConstruccion, lisTipoDireccion]) => {
        seguroAnalizamos.forEach( e => {
          if ( e.indicadorHabilitado ) {
            const tiposDirecciones = lisTipoDireccion.filter( x => x.idProductoSeguro === e.idProductoSeguro );
            const tiposViviendas = lisProductoClaseVivienda.filter( x => x.idProductoSeguro === e.idProductoSeguro );
            const tiposConstrucciones = lisProductoTipoConstruccion.filter( x => x.idProductoSeguro === e.idProductoSeguro );
            e.tipoDireccion = tiposDirecciones.map( s => s.tipoDireccion ).join( ',' );
            e.claseVivienda = tiposViviendas.map( s => s.claseVivienda ).join( ',' );
            e.tipoConstruccion = tiposConstrucciones.map( s => s.tipoConstruccionVivienda ).join( ',' );
            this.lisProductoSeguroAnalizamos.push( e );
          }
        } );

        this.lisProductoSeguroAnalizamos.sort( ( a, b ) => new Date( b.auditoriaFecha ).getTime() - new Date( a.auditoriaFecha ).getTime() );
        this.carTablaSeguroAnalizamos = false;
      });

      this.proDesembolsoServicio.listadoPorProducto( idProducto ).subscribe( desembolso => {
        this.lisProductoDesembolso = desembolso;
        this.carTablaDesembolso = false;
      } );

      this.productosMediosAsociadosService.listadoHabilitadoxProducto( idProducto ).subscribe( productosMediosAsociados => {
        this.productosMediosAsociados = productosMediosAsociados.filter(s => s.indicadorHabilitado);
        this.mediosAsociados = this.productosMediosAsociados.map( a => a.medioAsociadoCuenta ).join( ', ' );
      } );

      this.productosSolicitudesService.listadoHabilitadoxProducto( idProducto ).subscribe( productosSolicitudesLlaves => {
        this.productosSolicitudesLlaves = productosSolicitudesLlaves.filter(s => s.indicadorHabilitado);;
        this.solicitudesLlaves = this.productosSolicitudesLlaves.map( a => a.solicitudesLlaves ).join( ', ' );

      } );



      /*

      this.proFormaDesembolsoServicio.listadoPorProducto( idProducto ).subscribe( formaDesembolso => {
        this.lisProductoFormaDesembolso = formaDesembolso.filter( k => k.indicadorHabilitado );
        this.carTablaFormaDesembolso = false;
      } );

      */

      this.proRestriccionOficinaServicio.listadoPorProducto( idProducto ).subscribe( restriccion => {
        this.lisProductoRestriccionOficina = restriccion.filter( k => k.indicadorHabilitado );
        this.carTablaRestriccionOficina = false;
      } );

      this.proRestriccionBarrioServicio.listadoPorProducto( idProducto ).subscribe( restriccionBarrio => {
        this.lisProductoRestriccionBarrio = restriccionBarrio.filter( k => k.indicadorHabilitado );
        this.carTablaRestriccionBarrio = false;
      } );

      this.proReglaNegocioServicio.listadoproductosreglanegocio( idProducto ).subscribe( lisReglaNegocio => {
        this.lisReglasNegocios = lisReglaNegocio;
        this.carTablaReglasNegocios = false;
      } );

      /*this.proRespaldoServicio.listadoPorProducto( idProducto ).subscribe( lisProductos => {
        lisProductos.map( ( s: ProductosRespaldos ) => {
          s.rangoMonto = s.rangoInferior + ' - ' + s.rangoSuperior;
          this.lisProductoRespaldos.push( s );
        } );
        this.carTablaProductosRespaldos = false;
      } );*/


    } );
  }

  cargarlogoInicial(idAdjuntoIcono) {
    this.adjuntosService.descargarArchivo( this.producto.idAdjuntoIcono ).subscribe( adjunto => {
      let reader = new FileReader();
      reader.addEventListener( 'load', () => {
        console.log(adjunto);
        this.imagen = reader.result;
      }, false );
      if ( adjunto ) {
        reader.readAsDataURL( adjunto );
      }
    })
  }

  cargarColumnas() {

    this.colPlanCargo = [
      {
        field: 'formaDesembolso',
        header: this.navServicio.buscarMensaje( 'PRODUCTOPLANCARGO.LBL_TIPOESPECIE' ),
        sort: false
      },
      { field: 'nombrePlanCargo', header: this.navServicio.buscarMensaje( 'PRODUCTOPLANCARGO.LBL_PLANCARGO' ), sort: false },
      { field: 'indicadorDigital', header: this.navServicio.buscarMensaje( 'PRODUCTOPLANCARGO.LBL_INDICADIGITAL' ), sort: false },
      { field: 'indicadorTradicional', header: this.navServicio.buscarMensaje( 'PRODUCTOPLANCARGO.LBL_INDICATRADICIONAL' ), sort: false },
      { field: 'indicadorDefault', header: this.navServicio.buscarMensaje( 'PRODUCTOPLANCARGO.LBL_INDICAPREDETERMINADO' ), sort: false }
    ];

    this.colDestinos = [
      { field: 'idProductoDestino', header: this.navServicio.buscarMensaje( 'LBL_ID' ), sort: false },
      { field: 'nombreDestinoProducto', header: this.navServicio.buscarMensaje( 'PRODUCTODESTINO.LBL_DESTINO' ), sort: false }
    ];

    this.colMontos = [
      { field: 'rango', header: this.navServicio.buscarMensaje( 'PRODUCTOMONTO.LBL_RANGOMONTO' ), sort: false },
      { field: 'plazoMaximo', header: this.navServicio.buscarMensaje( 'PRODUCTOMONTO.LBL_PLAZOMAXIMO' ), sort: false },
      { field: 'plazoMaximoGarantiaIdonea', header: this.navServicio.buscarMensaje( 'PRODUCTOMONTO.LBL_PLAXOMAXIMOGARANTIAMESES' ), sort: false },
      { field: 'indicadorAnalizamos', header: this.navServicio.buscarMensaje( 'PRODUCTOMONTO.LBL_INDICADORANALIZAMOS' ), sort: false },
      { field: 'indicadorFlujoDigital', header: this.navServicio.buscarMensaje( 'PRODUCTOMONTO.LBL_INDICADORDIGITAL' ), sort: false }
    ];

    this.colMontosDestinos = [
      { field: 'nombreDestinoProducto', header: this.navServicio.buscarMensaje( 'PRODUCTODESTINOMONTO.LBL_DESTINO' ), sort: false },
      { field: 'rangoMonto', header: this.navServicio.buscarMensaje( 'PRODUCTODESTINOMONTO.LBL_RANGOMONTO' ), sort: false },
      { field: 'rangoPlazo', header: this.navServicio.buscarMensaje( 'PRODUCTODESTINOMONTO.LBL_RANGOPLAZO' ), sort: false },
      { field: 'nombrePerfilRiesgo', header: this.navServicio.buscarMensaje( 'PRODUCTODESTINOMONTO.LBL_PERFIL' ), sort: false },
      { field: 'plazoMaximoGarantiaIdonea', header: this.navServicio.buscarMensaje( 'PRODUCTOMONTO.LBL_PLAZOMAXIMOGARANTIAIDONEA' ), sort: false }
    ];

    this.colMontosAliados = [
      { field: 'nombreRiesgo', header: this.navServicio.buscarMensaje( 'PRODUCTOMONTOALIADO.LBL_PERFIL' ), sort: false },
      { field: 'ciclo', header: this.navServicio.buscarMensaje( 'PRODUCTOMONTOALIADO.LBL_CICLO' ), sort: false },
      { field: 'montoMaximo', header: this.navServicio.buscarMensaje( 'PRODUCTOMONTOALIADO.LBL_MONTOMAXIMO' ), sort: false },
      { field: 'plazoMaximo', header: this.navServicio.buscarMensaje( 'PRODUCTOMONTOALIADO.LBL_PLAZOMAXIMO' ), sort: false },
      { field: 'plazoMaximoGarantiaIdonea', header: this.navServicio.buscarMensaje( 'PRODUCTOMONTO.LBL_PLAZOMAXIMOGARANTIAIDONEA' ), sort: false }
    ];

    this.colFrecuencias = [
      { field: 'idProductoFrecuencia', header: this.navServicio.buscarMensaje( 'LBL_ID' ), sort: false },
      { field: 'nombreFrecuenciaProducto', header: this.navServicio.buscarMensaje( 'PRODUCTOFRECUENCIA.LBL_FRECUENCIA' ), sort: false },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    this.colGarantias = [
      { field: 'perfilRiesgo', header: this.navServicio.buscarMensaje( 'PRODUCTOGARANTIA.LBL_PERFIL' ), sort: false },
      { field: 'rangoMonto', header: this.navServicio.buscarMensaje( 'PRODUCTOGARANTIA.LBL_RANGOMONTO' ), sort: false },
      { field: 'minimoCodeudores', header: this.navServicio.buscarMensaje( 'PRODUCTOGARANTIA.LBL_CODEUDOR' ), sort: false },
      { field: 'nivelAprueba', header: this.navServicio.buscarMensaje( 'PRODUCTOGARANTIA.LBL_NIVELAPRUEBA' ), sort: false },
      { field: 'nivelExcepcion', header: this.navServicio.buscarMensaje( 'PRODUCTOGARANTIA.LBL_NIVELEXCEPCION' ), sort: false }
    ];

    this.colRenovacion = [
      { field: 'nombreFrecuenciaProducto', header: this.navServicio.buscarMensaje( 'PRODUCTORENOVACION.LBL_FRECUENCIA' ), sort: false },
      { field: 'rangoPlazo', header: this.navServicio.buscarMensaje( 'PRODUCTORENOVACION.LBL_PLAZOCREDITO' ), sort: false },
      { field: 'minimoCuotasPagas', header: this.navServicio.buscarMensaje( 'PRODUCTORENOVACION.LBL_CUOTASPAGAR' ), sort: false },
      { field: 'perfilRiesgo', header: this.navServicio.buscarMensaje( 'PRODUCTORENOVACION.LBL_PERFIL' ), sort: false },
      { field: 'nivelAprueba', header: this.navServicio.buscarMensaje( 'PRODUCTORENOVACION.LBL_NIVELAPRUEBA' ), sort: false },
      { field: 'nivelExcepcion', header: this.navServicio.buscarMensaje( 'PRODUCTORENOVACION.LBL_NIVELEXCEPCION' ), sort: false }
    ];

    this.colEstados = [
      { field: 'nombreEstado', header: this.navServicio.buscarMensaje( 'PRODUCTOESTADO.LBL_ESTADO' ), sort: false },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: false },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    this.colEstadoRelaciones = [
      { field: 'nombreEstadoPrincipal', header: this.navServicio.buscarMensaje( 'PRODUCTOESTADO.LBL_DESDEESTADO' ), sort: false },
      { field: 'nombreEstado', header: this.navServicio.buscarMensaje( 'PRODUCTOESTADO.LBL_HASTAESTADO' ), sort: false },
      { field: 'indicadorMantieneFase', header: this.navServicio.buscarMensaje( 'PRODUCTOESTADO.LBL_INDICADORFASE' ), sort: false },
      { field: 'nombreFuncionalidadPadre', header: this.navServicio.buscarMensaje( 'PRODUCTOESTADO.LBL_FORMULARIO' ), sort: false },
      { field: 'nombreFuncionalidadHijo', header: this.navServicio.buscarMensaje( 'PRODUCTOESTADO.LBL_CONTROL' ), sort: false },
      { field: 'indicadorSolicitudTradicional', header: this.navServicio.buscarMensaje( 'PRODUCTOESTADO.LBL_SOLICITUD' ), sort: false },
      { field: 'preAprobado', header: this.navServicio.buscarMensaje( 'PRODUCTOESTADO.LBL_PREAPROBADO' ), sort: false }
    ];

    this.colReferencias = [
      { field: 'tipoReferencia', header: this.navServicio.buscarMensaje( 'PRODUCTOREFERENCIA.LBL_TIPOREFERENCIA' ), sort: false },
      { field: 'tipoVinculacion', header: this.navServicio.buscarMensaje( 'PRODUCTOREFERENCIA.LBL_TIPOVINCULACION' ), sort: false },
      { field: 'tipoPersona', header: this.navServicio.buscarMensaje( 'PRODUCTOREFERENCIA.LBL_NATURALEZA' ), sort: false },
      { field: 'numeroReferencias', header: this.navServicio.buscarMensaje( 'PRODUCTOREFERENCIA.LBL_NUMEROREFERENCIAS' ), sort: false },
      { field: 'funcionaliad', header: this.navServicio.buscarMensaje( 'PRODUCTOREFERENCIA.LBL_FUNCIONALIDAD' ), sort: false },
      { field: 'obligatorio', header: this.navServicio.buscarMensaje( 'PRODUCTOREFERENCIA.LBL_OBLIGATORIO' ), sort: false },
    ];

    this.colActividades = [
      { field: 'segmento', header: this.navServicio.buscarMensaje( 'PRODUCTOACTIVIDAD.LBL_SEGMENTO' ), sort: false },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: false }
    ];

    this.colFrecuenciaAliados = [
      { field: 'nombreFrecuenciaProducto', header: this.navServicio.buscarMensaje( 'PRODUCTOFRECUENCIA.LBL_FRECUENCIA' ), sort: false },
      { field: 'numeroCuotas', header: this.navServicio.buscarMensaje( 'PRODUCTOFRECUENCIA.LBL_NUMEROCUOTAS' ), sort: false },
      {
        field: 'plazo',
        header: this.navServicio.buscarMensaje( 'PRODUCTOFRECUENCIA.LBL_PLAZO' ) + (this.navServicio.buscarMensaje( 'PRODUCTOFRECUENCIA.LBL_DIAS' )),
        sort: false
      }
    ];

    this.colControles = [
      { field: 'nombreFase', header: this.navServicio.buscarMensaje( 'PRODUCTOCONTROL.LBL_FASE' ), sort: true },
      { field: 'control', header: this.navServicio.buscarMensaje( 'PRODUCTOCONTROL.LBL_CONTROL' ), sort: true },
      { field: 'indicadorSolicitudTradicional', header: this.navServicio.buscarMensaje( 'PRODUCTOCONTROL.LBL_SOLICITUDTRADICIONAL' ), sort: true },
      { field: 'indicadorPreaprobado', header: this.navServicio.buscarMensaje( 'PRODUCTOCONTROL.LBL_PREAPROBADO' ), sort: true },
    ];

    this.colCuestionarios = [
      { field: 'nombreCuestionario', header: this.navServicio.buscarMensaje( 'PRODUCTOCUESTIONARIO.LBL_CUESTIONARIO' ), sort: false },
      { field: 'ponderacion', header: this.navServicio.buscarMensaje( 'PRODUCTOCUESTIONARIO.LBL_CONCEPTOMALO' ), sort: false },
      { field: 'nombreEstado', header: this.navServicio.buscarMensaje( 'PRODUCTOCUESTIONARIO.LBL_ESTADOCALIFICACION' ), sort: false },
      { field: 'ponderacion', header: this.navServicio.buscarMensaje( 'PRODUCTOCUESTIONARIO.LBL_CONCEPTOBUENO' ), sort: false },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: false }
    ];

    this.colConfirmacionVinculacion = [
      { field: 'nombreTipoVinculacion', header: this.navServicio.buscarMensaje( 'PRODUCTOCONFVINC.LBL_VINCULACION' ), sort: false },
      { field: 'nombreCuestionario', header: this.navServicio.buscarMensaje( 'PRODUCTOCONFVINC.LBL_CUESTIONARIO' ), sort: false }
    ];

    this.colAutorizacion = [
      { field: 'nombreAutorizacion', header: this.navServicio.buscarMensaje( 'PRODUCTOAUTORIZACION.LBL_AUTORIZACION' ), sort: false },
      { field: 'nombrePlantilla', header: this.navServicio.buscarMensaje( 'PRODUCTOAUTORIZACION.LBL_PLANTILLA' ), sort: false },
      { field: 'fase', header: this.navServicio.buscarMensaje( 'PRODUCTOAUTORIZACION.LBL_FASE' ), sort: false }
    ];

    this.colVoluntadPago = [
      { field: 'nombreCuestionario', header: this.navServicio.buscarMensaje( 'PRODUCTOCUESTIONARIO.LBL_CUESTIONARIO' ), sort: false },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: false }
    ];

    this.colSeguroAnalizamos = [
      { field: 'codigoSeguro', header: this.navServicio.buscarMensaje( 'SEGURO.LBL_CODIGO' ), sort: true },
      { field: 'nombreSeguro', header: this.navServicio.buscarMensaje( 'SEGURO.LBL_NOMBRE' ), sort: true },
      { field: 'indicadorBeneficiariosSeguro', header: this.navServicio.buscarMensaje( 'SEGURO.LBL_BENEFI' ), sort: true },
      { field: 'nombreCuestionarioSeguro', header: this.navServicio.buscarMensaje( 'SEGURO.LBL_DECLRIES' ), sort: true },
      {
        field: 'indicadorAplicaConfiguracionAdicional',
        header: this.navServicio.buscarMensaje( 'SEGURO.LBL_APLICACONFIGURACIONADICIONAL' ),
        sort: true
      },
      { field: 'tipoDireccion', header: this.navServicio.buscarMensaje( 'SEGURO.LBL_TIPODIRECCION' ), sort: true },
      { field: 'claseVivienda', header: this.navServicio.buscarMensaje( 'SEGURO.LBL_TIPOVIVIENDA' ), sort: true },
      { field: 'tipoConstruccion', header: this.navServicio.buscarMensaje( 'SEGURO.LBL_TIPOCONSTRUCCION' ), sort: true },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: true },
      { field: 'indicadorObligatorio', header: this.navServicio.buscarMensaje( 'PRODUCTO.LBL_OBLIGATORIO' ), sort: true },
    ];

    this.colDesembolso = [
      { field: 'rango', header: this.navServicio.buscarMensaje( 'PRODUCTODESEMBOLSO.LBL_RANGOMONTOAPROBADO' ), sort: false, colspan: 2 },
      { field: 'nombre', header: this.navServicio.buscarMensaje( 'PRODUCTODESEMBOLSO.LBL_RANGOPLAZOAPROBADO' ), sort: false, colspan: 2 },
      {
        field: 'fechaInicioVigencia',
        header: this.navServicio.buscarMensaje( 'PRODUCTODESEMBOLSO.LBL_RANGOTASAPRODUCTO' ),
        sort: false,
        colspan: 2
      },
      {
        field: 'limiteDiaDesembolso',
        header: this.navServicio.buscarMensaje( 'PRODUCTODESEMBOLSO.LBL_LIMITEDIADESEMBOLSO' ),
        sort: false,
        rowspan: 2
      },
      {
        field: 'nombreTipoCupo',
        header: this.navServicio.buscarMensaje( 'PRODUCTODESEMBOLSO.LBL_CANTDESEMBOLSO' ),
        sort: false,
        colspan: 2
      },
      {
        field: 'nombreClasificacion',
        header: this.navServicio.buscarMensaje( 'PRODUCTODESEMBOLSO.LBL_RANGOAPLICARPLAZO' ),
        sort: false,
        colspan: 2
      },
      {
        field: 'ampliarPlazo',
        header: this.navServicio.buscarMensaje( 'PRODUCTODESEMBOLSO.LBL_VECESAMPLIARPLAZO' ),
        sort: false,
        rowspan: 2
      },
      {
        field: 'diaMaximoMoraCliente',
        header: this.navServicio.buscarMensaje( 'PRODUCTODESEMBOLSO.LBL_DIASMAXMORA' ),
        sort: false,
        rowspan: 2
      },
      {
        field: 'diaMaximoMoraProducto',
        header: this.navServicio.buscarMensaje( 'PRODUCTODESEMBOLSO.LBL_DIASMAXMORAPRODUCTO' ),
        sort: false,
        rowspan: 2
      }
    ];

    this.colDesembolso2 = [
      { field: 'rangoMontoAprobadoMinimo', header: this.navServicio.buscarMensaje( 'PRODUCTODESEMBOLSO.LBL_VALORMINIMO' ), sort: false, },
      { field: 'rangoMontoAprobadoMaximo', header: this.navServicio.buscarMensaje( 'PRODUCTODESEMBOLSO.LBL_VALORMAXIMO' ), sort: false },
      { field: 'rangoPlazoAprobadoMinimo', header: this.navServicio.buscarMensaje( 'PRODUCTODESEMBOLSO.LBL_VALORMINIMO' ), sort: false, },
      { field: 'rangoPlazoAprobadoMaximo', header: this.navServicio.buscarMensaje( 'PRODUCTODESEMBOLSO.LBL_VALORMAXIMO' ), sort: false },
      { field: 'rangoTasaProductoMinimo', header: this.navServicio.buscarMensaje( 'PRODUCTODESEMBOLSO.LBL_VALORMINIMO' ), sort: false, },
      { field: 'rangoTasaProductoOrdinario', header: this.navServicio.buscarMensaje( 'PRODUCTODESEMBOLSO.LBL_VALORMAXIMO' ), sort: false },
      {
        field: 'minimoDiaCantidadDesembolsoParcial',
        header: this.navServicio.buscarMensaje( 'PRODUCTODESEMBOLSO.LBL_VALORMINIMO' ),
        sort: false
      },
      {
        field: 'maximoDiaCantidadDesembolsoParcial',
        header: this.navServicio.buscarMensaje( 'PRODUCTODESEMBOLSO.LBL_VALORMAXIMO' ),
        sort: false,
      },
      { field: 'rangoAmpliarPlazoMinimoDia', header: this.navServicio.buscarMensaje( 'PRODUCTODESEMBOLSO.LBL_VALORMINIMO' ), sort: false, },
      { field: 'rangoAmpliarPlazoMaximoDia', header: this.navServicio.buscarMensaje( 'PRODUCTODESEMBOLSO.LBL_VALORMAXIMO' ), sort: false },
    ];

    this.colFormaDesembolso = [
      { field: 'formaDesembolso', header: this.navServicio.buscarMensaje( 'FORMADESEMBOLSO.LBL_TIPOESPECIE' ), sort: false },
      { field: 'porcentaje', header: this.navServicio.buscarMensaje( 'FORMADESEMBOLSO.LBL_PORCENTAJE' ), sort: false }
    ];

    this.colRestriccionOficina = [
      { field: 'nombreOficina', header: this.navServicio.buscarMensaje( 'PRODUCTO.LBL_OFICINAS' ), sort: false }
    ];

    this.colRestriccionBarrio = [
      { field: 'nombreBarrio', header: this.navServicio.buscarMensaje( 'PRODUCTO.LBL_UBICACIONESHABILITADAS' ), sort: false }
    ];

    this.colReglasNegocio = [
      { field: 'nombreProductoRegla', header: this.navServicio.buscarMensaje( 'PRODUCTOREGLANEGOCIO.LBL_NOMBREPRODUCTO' ), sort: true },
      {
        field: 'indicadorRecogerCreditos',
        header: this.navServicio.buscarMensaje( 'PRODUCTOREGLANEGOCIO.LBL_RECOGERCREDITOS' ),
        sort: true
      },
      { field: 'indicadorPrimerCredito', header: this.navServicio.buscarMensaje( 'PRODUCTOREGLANEGOCIO.LBL_PRIMERCRETIDO' ), sort: true },
      {
        field: 'mesesMaximoCancelacion',
        header: this.navServicio.buscarMensaje( 'PRODUCTOREGLANEGOCIO.LBL_MESESCANCELACION' ),
        sort: true
      },
      { field: 'porcentajeCancelacion', header: this.navServicio.buscarMensaje( 'PRODUCTOREGLANEGOCIO.LBL_PORCENTAJE' ), sort: true },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: true }
    ];

    this.colProductosRespaldos = [
      { field: 'nombreRespaldo', header: this.navServicio.buscarMensaje( 'PRODUCTORESPALDO.LBL_RESPALDOS' ), sort: false },
      { field: 'rangoSMLV', header: this.navServicio.buscarMensaje( 'PRODUCTORESPALDO.LBL_RANGOSMLV' ), sort: false },
      { field: 'indicadorObligatorio', header: this.navServicio.buscarMensaje( 'PRODUCTORESPALDO.LBL_OBLIGATORIO' ), sort: false },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: true }
    ];

  }

  regresar() {
    this.location.back();
  }

  buscarTipoDato( tipo: string ): ListaItem {
    const a = this.lisTipoDatoTodos.find( x => x.idLista === tipo );
    if ( a ) {
      return a;
    } else {
      return new ListaItem();
    }
  }



  abrirModalEstadoRelaciones( proEstado: ProductoEstado ) {
    this.proEstadoSeleccionado = proEstado;
    this.lisEstadoRelaciones = [];
    this.mosEstadoRelaciones = true;
    this.carTablaEstadoRelaciones = true;

    forkJoin( [
      this.proEstadoRelacionServicio.listadoPorProductoEstado( proEstado.idProductoEstado ),
      this.proEstadoRelacionTipoPreAprobadoServicio.listado()
    ] ).subscribe( ( [lisRelaciones, lisTiposPreaprobados] ) => {
      this.lisEstadoRelacionesTiposPreaprobados = lisTiposPreaprobados;
      lisRelaciones.map( ( s: ProductoEstadoRelacion ) => {
        s.nombreEstadoPrincipal = proEstado.nombreEstado;
        s.preAprobado = s.indicadorPreaprobado ? this.unirTipoPreAprobado( s.idProductoEstadoRelacion ) : '';
        this.lisEstadoRelaciones.push( s );
      } );
      this.carTablaEstadoRelaciones = false;
    }, error => {
      this.carTablaEstadoRelaciones = false;
    } );
  }

  cerrarModalEstadoRelaciones() {
    this.proEstadoSeleccionado = null;
    this.lisEstadoRelaciones = [];
    this.mosEstadoRelaciones = false;
  }

  unirTipoPreAprobado( idProductoEstadoRelacion: string ) {
    const relaciones = this.lisEstadoRelacionesTiposPreaprobados
      .filter( l => l.idProductoEstadoRelacion === idProductoEstadoRelacion && l.indicadorHabilitado )
      .map( t => t.tipoPreaprobado );
    if ( relaciones.length > 0 ) {
      return relaciones.join( ' - ' );
    }
    return '';
  }

  abrirModalFrecuenciaCuotas(proFrecuencia: ProductoFrecuencia){
    this.proFrecuencia = proFrecuencia;
    this.showModalFrecuenciasCuotas = true;
  }

  cerrarModalFrecuenciaCuotas(){
    this.proFrecuencia = null;
    this.showModalFrecuenciasCuotas = false;
  }

  abrirAcordeon( evento: number ) {
    switch ( evento ) {
      case 0: {
        this.tabSeleccionado = 'PRODUCTO';
        break;
      }
      case 1: {
        this.tabSeleccionado = 'INDICADORES';
        break;
      }
      default: {
        break;
      }
    }
  }

  protected readonly codigosProducto = TiposProductosBancarios;
  protected readonly tiposCuentaAhorro = TiposCuentaAhorro;
}
